import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


function DownloadIcon(props: SvgIconProps) {
    return (
      <SvgIcon {...props}>
        <path 
        d="M23,12.543H18.984l2.008-2.008a2.091,2.091,0,0,0-1.476-3.567H16.728V2.091A2.091,2.091,0,0,0,14.638,0H10.457A2.091,2.091,0,0,0,8.366,2.091V6.968H5.579A2.09,2.09,0,0,0,4.1,10.535L6.11,12.543H2.091A2.091,2.091,0,0,0,0,14.634v5.575A2.091,2.091,0,0,0,2.091,22.3H23a2.091,2.091,0,0,0,2.091-2.091V14.634A2.091,2.091,0,0,0,23,12.543ZM5.575,9.059h4.878V2.091h4.181V9.059h4.878l-6.968,6.968ZM23,20.208H2.091V14.634h6.1l2.87,2.87a2.091,2.091,0,0,0,2.957,0l2.87-2.87H23Zm-3.833-2.787a1.045,1.045,0,1,1,1.045,1.045A1.043,1.043,0,0,1,19.163,17.421Z" />
      </SvgIcon>
    );
  }


export default DownloadIcon;